export default __webpack_public_path__ + "81d232c565ded62d9cb0b741264a116e.svg";